
import { useState } from "react";
import url from "../api/url";
import { elToast } from "../functions/Alerta";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";


export default function useFormularioVacaciones() {


    // variables
    const [camposForm, setCamposForm] = useState({
        fecha_propuesta: '0'
    })
    const [mostrarAlerta, setMostrarAlerta] = useState(false)
    const { URL } = url()
    const objLogueado = useEmpleadoStore(state => state.objLogueado)



    // funciones
    function guardar( e ) {
        e.preventDefault()

        if (camposForm.fecha_propuesta === '0') {
            elToast( 'Por favor, selecciona un mes', 'info' )
            return
        }

        let body = {
            ...camposForm,
            email: objLogueado.email,
            funcion: 'guardarSolicitudVacaciones'
        }

        fetch( URL, {
            method: 'post',
            body: JSON.stringify( body )
        })
        .then( res => res.json() )
        .then( e => {

            if (e.codigo === 1) {
                setMostrarAlerta( true )
                elToast( 'Solicitud de vacaciones enviada', 'success' )
                setCamposForm({
                    fecha_propuesta: '0'
                })
                // eslint-disable-next-line
            } else if (e.codigo == 0) {
                elToast( e.mensaje, 'info' )
                setMostrarAlerta( false )
            } else {
                elToast( e.mensaje, 'error' )
                setMostrarAlerta( false )
            }

        })
        .catch( a => {
            elToast( 'Hay problemas al guardar esta solicitud. Intenta iniciar sesión nuevamente.', 'error' )
        })


    }


    // effects


    return {
        camposForm, setCamposForm, guardar, mostrarAlerta, setMostrarAlerta
    }
}
